/* eslint-disable object-curly-spacing */
import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import countries from '../utils/formStates';
import '../css/CareersPage.css';
/**
 * This function renders the Employment page
 * @component EmploymentPage
 * @return {Component} EmploymentPage component
 */
export default function CareersPage() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [address, setAddress] = useState('');
  const [suite, setSuite] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  // const [resume, setResume] = useState('');
  // const [coverLetter, setCoverLetter] = useState('');

  const handleSubmit = (event) => {
    console.log(`
      FirstName: ${firstName}
      LastName: ${lastName}
      Address: ${address}
      Suite: ${suite}
      City: ${firstName}
      State: ${state}
      Zip: ${zip}
      PhoneNumber: ${phoneNumber}
      Email: ${email}
    `);

    event.preventDefault();
  };

  return (
    <Card
      className="careers-container"
      style={{
        padding: '50px',
        width: '1200px',
        margin: '30px auto 30px auto',
      }}
    >
      <h1 style={{textAlign: 'center'}}>Careers</h1>
      <br />
      <p style={{ fontSize: '20px', lineHeight: '40px' }}>
        The Advanced Intelligence Services Corporation seeks progressive,
        responsible individuals to help achieve our evolving research,
        marketing, and administrative goals. To apply, fill out the application
        below and attach your most recent resume, with cover letter. Thank you
        for your interest in Advanced Intelligence Services Corp.
      </p>
      <br />
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <label>
            First Name:
            <input
              name="firstName"
              type="firstName"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </label>

          <label>
            Last Name:
            <input
              name="lastName"
              type="lastName"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </label>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <label>
            Address:
            <input
              name="address"
              type="address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              required
            />
          </label>

          <label>
            Suite or Apt. Number:
            <input
              name="suite"
              type="suite"
              value={suite}
              onChange={(e) => setSuite(e.target.value)}
            />
          </label>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <label>
            City:
            <input
              name="city"
              type="city"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              required
            />
          </label>

          <label>
            State:
            <select
              name="state"
              value={state}
              onChange={(e) => setState(e.target.value)}
              required
            >
              <option key=""></option>
              {countries.map((state) => (
                <option key={state}>{state}</option>
              ))}
            </select>
          </label>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <label>
            Zip Code:
            <input
              name="zip"
              type="zip"
              value={zip}
              onChange={(e) => setZip(e.target.value)}
              required
            />
          </label>

          <label>
            City:
            <input
              name="phoneNumber"
              type="phoneNumber"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
            />
          </label>
        </div>

        <label>
          Email:
          <input
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <button type="button">Submit</button>
      </form>
    </Card>
  );
}
